import $ from 'jquery';

export class VehicleIntroThumbs {
	constructor(el, flkty) {
		this.DOM = { el };

		this.flkty = flkty;
		this.ctrls = {
			prev: this.flkty.prevButton.element,
			next: this.flkty.nextButton.element,
		};

		this.initEvents();
	}
	initEvents = () => {
		this.ctrls.prev.addEventListener('click', () => this.toggleCompanion('previous'));
		this.ctrls.next.addEventListener('click', () => this.toggleCompanion('next'));
	};
	toggleCompanion = (direction) => {
		this.flkty.navCompanion[direction]();
	};
}

export class VehicleIntro {
	constructor(el, flkty) {
		this.DOM = { el: el };
		this.DOM.triggers = Array.from(document.querySelectorAll('.vehicle-intro-images-button'));
		this.DOM.images = Array.from(this.DOM.el.querySelectorAll('[data-slide-image]'));

		this.fancyboxItems = this.DOM.images.map((image) => {
			return { src: image.dataset.slideImage };
		});
		this.flickity = flkty;

		this.initEvents();
	}

	initEvents = () => {
		this.DOM.triggers.forEach((trigger) => trigger.addEventListener('click', this.openFancybox));
		this.DOM.images.forEach((image) => image.addEventListener('click', this.openFancybox));

		this.flickity.on('dragStart', () =>
			this.flickity.slider.childNodes.forEach((slide) => (slide.style.pointerEvents = 'none'))
		);
		this.flickity.on('dragEnd', () =>
			this.flickity.slider.childNodes.forEach((slide) => (slide.style.pointerEvents = 'all'))
		);
	};

	openFancybox = () => {
		const index = this.flickity.selectedIndex;

		$.fancybox.open(
			this.fancyboxItems,
			{
				beforeShow: (instance, current, event) => {
					this.flickity.select(current.index);
				},
				loop: true,
			},
			index
		);
	};
}
